import { render, staticRenderFns } from "./EditReasonDialog.vue?vue&type=template&id=ddb0c97a&scoped=true"
import script from "./EditReasonDialog.vue?vue&type=script&lang=js"
export * from "./EditReasonDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddb0c97a",
  null
  
)

export default component.exports